module.exports = __webpack_public_path__ + "static/img/20220507_03.7f9ada3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20220507_03.png
// module id = /ygC
// module chunks = 0